import React from 'react';
import { IOldIconProps } from './type';

const New: React.FC<IOldIconProps> = ({ width, height, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      width={width || 32}
      height={height || 32}
      {...props}
    >
      <defs>
        <style type="text/css">
          {`
              .new-icon-cls-1{fill:#fab601;stroke:#000;stroke-miterlimit:10;stroke-width:1.2px;
              `}
        </style>
      </defs>
      <g id="Calque_2" data-name="Calque 2">
        <path
          className="new-icon-cls-1"
          d="M28.38,22.37,24.81,23.8a1.19,1.19,0,0,0-.68.71l-1.27,3.63a1.2,1.2,0,0,1-1.6.7l-3.54-1.52a1.2,1.2,0,0,0-1,0L13.27,29a1.21,1.21,0,0,1-1.63-.64L10.21,24.8a1.14,1.14,0,0,0-.71-.68L5.87,22.85a1.2,1.2,0,0,1-.7-1.6l1.51-3.53a1.18,1.18,0,0,0,0-1L5,13.27a1.2,1.2,0,0,1,.63-1.63L9.2,10.22a1.23,1.23,0,0,0,.69-.72l1.27-3.62a1.2,1.2,0,0,1,1.6-.7l3.53,1.51a1.18,1.18,0,0,0,1,0L20.75,5a1.19,1.19,0,0,1,1.62.63L23.8,9.21a1.23,1.23,0,0,0,.72.69l3.62,1.27a1.2,1.2,0,0,1,.71,1.6L27.33,16.3a1.2,1.2,0,0,0,0,1L29,20.75A1.18,1.18,0,0,1,28.38,22.37Z"
        />
        <path d="M13.28,19.67a.52.52,0,0,1-.43-.21l-2.24-3v2.66a.53.53,0,0,1-.53.53.53.53,0,0,1-.53-.53V14.88a.53.53,0,0,1,.36-.51.54.54,0,0,1,.6.19l2.23,3V14.88a.54.54,0,1,1,1.07,0v4.26a.55.55,0,0,1-.36.51Z" />
        <path d="M17.54,19.67H15.41a.53.53,0,0,1-.53-.53V14.88a.53.53,0,0,1,.53-.54h2.13a.54.54,0,0,1,0,1.07h-1.6v3.2h1.6a.53.53,0,0,1,0,1.06Z" />
        <path d="M17.54,17.54H15.41a.53.53,0,0,1-.53-.53.52.52,0,0,1,.53-.53h2.13a.52.52,0,0,1,.53.53A.53.53,0,0,1,17.54,17.54Z" />
        <path d="M22.87,19.67a.52.52,0,0,1-.5-.36l-.56-1.68-.56,1.68a.52.52,0,0,1-.53.36.53.53,0,0,1-.5-.4L19.16,15a.53.53,0,0,1,.38-.64.54.54,0,0,1,.65.39l.62,2.49.49-1.47a.56.56,0,0,1,1,0l.49,1.47.62-2.49a.53.53,0,0,1,.65-.39.52.52,0,0,1,.38.64l-1.06,4.27a.53.53,0,0,1-.5.4Z" />
      </g>
    </svg>
  );
};

export default New;
